import { Target, Zap, Users, Wrench, Heart, Smile, TrendingUp, Globe, Award, Brain, DollarSign, Crown, Flame, MessageCircle, Sparkles, Dumbbell, HeartHandshake, HandHeart, Church } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export interface Wall {
  id: string;
  name: string;
  icon: LucideIcon;
}

export interface Driver {
  id: string;
  name: string;
}

export interface DriverSet {
  id: string;
  name: string;
  description: string;
  clarity: string;
  action: string;
  growth: string;
}

export const WALLS: Wall[] = [
  { id: 'adventure', name: 'Adventure', icon: Target },
  { id: 'career', name: 'Career', icon: TrendingUp },
  { id: 'community', name: 'Community', icon: HandHeart },
  { id: 'connection', name: 'Connection', icon: MessageCircle },
  { id: 'craft', name: 'Craft', icon: Wrench },
  { id: 'faith', name: 'Faith', icon: Church },
  { id: 'family', name: 'Family', icon: Heart },
  { id: 'fitness', name: 'Fitness', icon: Dumbbell },
  { id: 'fun', name: 'Fun', icon: Smile },
  { id: 'health', name: 'Health', icon: Sparkles },
  { id: 'impact', name: 'Impact', icon: Globe },
  { id: 'legacy', name: 'Legacy', icon: Award },
  { id: 'mindset', name: 'Mindset', icon: Brain },
  { id: 'money', name: 'Money', icon: DollarSign },
  { id: 'power', name: 'Power', icon: Crown },
  { id: 'romance', name: 'Romance', icon: HeartHandshake },
  { id: 'sex', name: 'Sex', icon: Flame },
  { id: 'social', name: 'Social', icon: Users },
  { id: 'spirit', name: 'Spirit', icon: Zap },
];

export const DEFAULT_WALLS = ['money', 'fun', 'sex', 'health'];

export const DRIVER_SETS: DriverSet[] = [
  {
    id: 'tactical',
    name: 'The Tactical Set',
    description: 'For builders and executors',
    clarity: 'Vision',
    action: 'Execution',
    growth: 'Scale',
  },
  {
    id: 'primal',
    name: 'The Primal Set',
    description: 'For raw authentic power',
    clarity: 'Truth',
    action: 'Drive',
    growth: 'Expansion',
  },
  {
    id: 'architect',
    name: 'The Architect Set',
    description: 'For systematic thinkers',
    clarity: 'Blueprint',
    action: 'Build',
    growth: 'Evolution',
  },
  {
    id: 'performance',
    name: 'The Performance Set',
    description: 'For results-driven achievers',
    clarity: 'Focus',
    action: 'Momentum',
    growth: 'Results',
  },
  {
    id: 'spiritual',
    name: 'The Spiritual/Alignment Set',
    description: 'For conscious creators',
    clarity: 'Awareness',
    action: 'Presence',
    growth: 'Abundance',
  },
];

export const DRIVERS: Driver[] = [
  { id: 'abundance', name: 'Abundance' },
  { id: 'action', name: 'Action' },
  { id: 'awareness', name: 'Awareness' },
  { id: 'blueprint', name: 'Blueprint' },
  { id: 'build', name: 'Build' },
  { id: 'clarity', name: 'Clarity' },
  { id: 'drive', name: 'Drive' },
  { id: 'evolution', name: 'Evolution' },
  { id: 'execution', name: 'Execution' },
  { id: 'expansion', name: 'Expansion' },
  { id: 'focus', name: 'Focus' },
  { id: 'growth', name: 'Growth' },
  { id: 'momentum', name: 'Momentum' },
  { id: 'presence', name: 'Presence' },
  { id: 'results', name: 'Results' },
  { id: 'scale', name: 'Scale' },
  { id: 'truth', name: 'Truth' },
  { id: 'vision', name: 'Vision' },
];

export const DEFAULT_DRIVERS = ['vision', 'execution', 'scale'];
